//@flow
import React from 'react';

type ModalProps = {
    onClose: () => void,
    show: boolean,
    children: any
};
type ModalState = {
    show: boolean
};

export default class Modal extends React.Component<ModalProps, ModalState> {
    static defaultProps = {
        'show': false
    };

    constructor(props: ModalProps): void {
        super(props);

        this.state = {
            show: this.props.show
        };
    }

    componentWillMount(): void {
        window.addEventListener('keyup', this.onModalKeyUp);
    }

    componentWillUnmount(): void {
        window.removeEventListener('keyup', this.onModalKeyUp);
    }

    componentWillReceiveProps(nextProps: ModalProps):void {
        if(this.state.show !== nextProps.show) {
            this.setState({show:nextProps.show});
        }
    }

    onModalKeyUp = (event: KeyboardEvent): void => {
        if(event.key === 'Enter') this.onClose();
    };

    onClose = (event?: MouseEvent): void => {
        if(event) event.stopPropagation();
        if(event) event.preventDefault();

        window.removeEventListener('keyup', this.onModalKeyUp);
        this.props.onClose ? this.props.onClose() : this.setState({ show: false } );
    };

    render (){
        return (
            <div className={"modal-shroud " + (this.state.show ? '':'hidden')} onClick={ this.onClose }>
                <div className="modal">
                    <button className="modal-close" onClick={ this.onClose }>×</button>
                    <div className="modal-content">
                        { this.props.children }
                    </div>
                </div>
            </div>
        )
    }
}
